var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "min-h-screen bg-gray-100"
  }, [_c('div', {
    staticClass: "mx-auto p-6"
  }, [_c('div', {
    staticClass: "flex justify-between items-end mb-6 mdmax:flex-col mdmax:items-stretch gap-4"
  }, [_c('div', {
    staticClass: "flex-1 mdmax:w-full"
  }, [_c('div', {
    staticClass: "grid grid-cols-1 md:grid-cols-3 gap-4"
  }, [_c('div', [_c('label', {
    staticClass: "text-base text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v(" Customer ")]), _c('CustomSelect', {
    attrs: {
      "options": _vm.customers,
      "default": _vm.selectedCustomer,
      "optionLabel": "customer_name",
      "placeholder": "Pilih customer"
    },
    on: {
      "input": function (val) {
        return _vm.selectedCustomer = val;
      },
      "change": _vm.onFilterChange
    }
  })], 1), _c('div', [_c('label', {
    staticClass: "text-base text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v(" Destination ")]), _c('TextField', {
    attrs: {
      "type": "text",
      "placeholder": "Cari destination..."
    },
    on: {
      "enter": _vm.onFilterChange
    },
    model: {
      value: _vm.destination,
      callback: function ($$v) {
        _vm.destination = $$v;
      },
      expression: "destination"
    }
  })], 1), _c('div', {
    staticClass: "flex items-center gap-3 pt-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.eligibleOnly,
      expression: "eligibleOnly"
    }],
    staticClass: "w-4 h-4",
    attrs: {
      "id": "eligible-only",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.eligibleOnly) ? _vm._i(_vm.eligibleOnly, null) > -1 : _vm.eligibleOnly
    },
    on: {
      "change": [function ($event) {
        var $$a = _vm.eligibleOnly,
            $$el = $event.target,
            $$c = $$el.checked ? true : false;

        if (Array.isArray($$a)) {
          var $$v = null,
              $$i = _vm._i($$a, $$v);

          if ($$el.checked) {
            $$i < 0 && (_vm.eligibleOnly = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.eligibleOnly = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.eligibleOnly = $$c;
        }
      }, _vm.onFilterChange]
    }
  }), _c('label', {
    staticClass: "text-sm text-neutral-700",
    attrs: {
      "for": "eligible-only"
    }
  }, [_vm._v(" Eligible only ")])])])]), _c('div', {
    staticClass: "flex mdmax:w-full justify-end gap-2"
  }, [_c('button', {
    staticClass: "px-4 py-2 bg-primary-500 text-white rounded-lg hover:bg-primary-600 font-medium",
    on: {
      "click": _vm.openCreateResiModal
    }
  }, [_vm._v(" + Tambah Resi ")])])]), _c('TableComponent', {
    attrs: {
      "columns": _vm.columns,
      "list": _vm.tableData
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function (_ref) {
        var entry = _ref.entry,
            column = _ref.column;
        return [column.field === 'action' ? _c('span', {
          staticClass: "flex gap-2"
        }, [_c('button', {
          staticClass: "px-3 py-1 rounded bg-neutral-200 text-neutral-700 hover:bg-neutral-300 text-sm",
          on: {
            "click": function ($event) {
              return _vm.$router.push(`/invoices/resi/${entry.id || entry.resi_id}`);
            }
          }
        }, [_vm._v(" Detail ")])]) : column.field === 'RowNumber' ? _c('span', {
          staticClass: "font-medium"
        }, [_vm._v(" " + _vm._s(entry.RowNumber) + " ")]) : column.field === 'eligible' ? _c('span', [_c('span', {
          staticClass: "px-2 py-1 rounded text-xs font-medium",
          class: entry.eligible ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-700'
        }, [_vm._v(" " + _vm._s(entry.eligible ? "Eligible" : "Not eligible") + " ")])]) : column.field === 'unit_price' ? _c('span', [_vm._v(" " + _vm._s(_vm.formatCurrency(entry.unit_price)) + " ")]) : column.field === 'total_price' ? _c('span', [_vm._v(" " + _vm._s(_vm.formatCurrency(entry.total_price)) + " ")]) : _c('span', [_vm._v(_vm._s(entry[column.field] || "-"))])];
      }
    }])
  }), _vm.tableData.length > 0 ? _c('div', {
    staticClass: "mt-6 mb-6 flex justify-between items-center mdmax:flex-col mdmax:items-start gap-4"
  }, [!_vm.isMobile ? _c('div', {
    staticClass: "text-sm font-medium text-neutral-500"
  }, [_vm._v(" Menampilkan " + _vm._s(_vm.start) + " - " + _vm._s(_vm.end) + " dari " + _vm._s(_vm.totalRecords) + " ")]) : _vm._e(), _c('Pagination', {
    attrs: {
      "currentPage": _vm.page,
      "totalCount": _vm.totalRecords,
      "pageSize": _vm.limit
    },
    on: {
      "onPageChange": _vm.changePage
    }
  })], 1) : _vm._e(), _c('Modal', {
    attrs: {
      "modalVisible": _vm.createModalVisible,
      "width": "720px"
    },
    on: {
      "close": _vm.closeCreateResiModal
    }
  }, [_c('div', {
    staticClass: "text-left",
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('h3', {
    staticClass: "text-lg font-bold text-neutral-800 mb-4"
  }, [_vm._v(" Tambah Resi ")]), _c('div', {
    staticClass: "grid grid-cols-1 md:grid-cols-2 gap-4"
  }, [_c('div', {
    staticClass: "md:col-span-2"
  }, [_c('TextField', {
    attrs: {
      "type": "date",
      "label": "Date",
      "required": ""
    },
    model: {
      value: _vm.createForm.date,
      callback: function ($$v) {
        _vm.$set(_vm.createForm, "date", $$v);
      },
      expression: "createForm.date"
    }
  })], 1), _c('div', {
    staticClass: "md:col-span-2"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v(" Customer ")]), _c('CustomSelect', {
    attrs: {
      "options": _vm.customers,
      "default": _vm.createFormCustomer,
      "optionLabel": "customer_name",
      "placeholder": "Pilih customer"
    },
    on: {
      "input": _vm.onCreateCustomerSelect
    }
  })], 1), _c('div', [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_c('span', {
    staticClass: "text-system-error"
  }, [_vm._v("*")]), _vm._v("Destination ")]), _c('CustomSelect', {
    attrs: {
      "options": _vm.destinationOptions,
      "default": _vm.createForm.destination,
      "placeholder": "Pilih destination"
    },
    on: {
      "input": function (val) {
        return _vm.createForm.destination = val;
      }
    }
  }), _vm.destinationOptionsLoading ? _c('p', {
    staticClass: "text-xs text-neutral-500 mt-1"
  }, [_vm._v(" Memuat destination... ")]) : _vm.createFormCustomer && _vm.destinationOptions.length === 0 ? _c('p', {
    staticClass: "text-xs text-neutral-500 mt-1"
  }, [_vm._v(" Belum ada konfigurasi harga untuk customer ini. Tambahkan di Customers → Prices. ")]) : _vm._e()], 1), _c('div', [_c('TextField', {
    attrs: {
      "label": "Resi Number",
      "required": "",
      "placeholder": "Nomor resi"
    },
    model: {
      value: _vm.createForm.resi_number,
      callback: function ($$v) {
        _vm.$set(_vm.createForm, "resi_number", $$v);
      },
      expression: "createForm.resi_number"
    }
  })], 1), _c('div', {
    staticClass: "md:col-span-2"
  }, [_c('div', {
    staticClass: "grid grid-cols-1 md:grid-cols-2 gap-3"
  }, [_c('label', {
    staticClass: "flex items-center gap-2 text-sm text-neutral-700"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.createForm.has_weight_detail,
      expression: "createForm.has_weight_detail"
    }],
    staticClass: "w-4 h-4",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.createForm.has_weight_detail) ? _vm._i(_vm.createForm.has_weight_detail, null) > -1 : _vm.createForm.has_weight_detail
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.createForm.has_weight_detail,
            $$el = $event.target,
            $$c = $$el.checked ? true : false;

        if (Array.isArray($$a)) {
          var $$v = null,
              $$i = _vm._i($$a, $$v);

          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.createForm, "has_weight_detail", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.createForm, "has_weight_detail", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.createForm, "has_weight_detail", $$c);
        }
      }
    }
  }), _vm._v(" has_weight_detail ")]), _c('label', {
    staticClass: "flex items-center gap-2 text-sm text-neutral-700"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.createForm.has_white_receipt,
      expression: "createForm.has_white_receipt"
    }],
    staticClass: "w-4 h-4",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.createForm.has_white_receipt) ? _vm._i(_vm.createForm.has_white_receipt, null) > -1 : _vm.createForm.has_white_receipt
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.createForm.has_white_receipt,
            $$el = $event.target,
            $$c = $$el.checked ? true : false;

        if (Array.isArray($$a)) {
          var $$v = null,
              $$i = _vm._i($$a, $$v);

          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.createForm, "has_white_receipt", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.createForm, "has_white_receipt", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.createForm, "has_white_receipt", $$c);
        }
      }
    }
  }), _vm._v(" has_white_receipt ")]), _c('label', {
    staticClass: "flex items-center gap-2 text-sm text-neutral-700"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.createForm.has_blue_receipt,
      expression: "createForm.has_blue_receipt"
    }],
    staticClass: "w-4 h-4",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.createForm.has_blue_receipt) ? _vm._i(_vm.createForm.has_blue_receipt, null) > -1 : _vm.createForm.has_blue_receipt
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.createForm.has_blue_receipt,
            $$el = $event.target,
            $$c = $$el.checked ? true : false;

        if (Array.isArray($$a)) {
          var $$v = null,
              $$i = _vm._i($$a, $$v);

          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.createForm, "has_blue_receipt", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.createForm, "has_blue_receipt", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.createForm, "has_blue_receipt", $$c);
        }
      }
    }
  }), _vm._v(" has_blue_receipt ")]), _c('label', {
    staticClass: "flex items-center gap-2 text-sm text-neutral-700"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.createForm.has_delivery_order,
      expression: "createForm.has_delivery_order"
    }],
    staticClass: "w-4 h-4",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.createForm.has_delivery_order) ? _vm._i(_vm.createForm.has_delivery_order, null) > -1 : _vm.createForm.has_delivery_order
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.createForm.has_delivery_order,
            $$el = $event.target,
            $$c = $$el.checked ? true : false;

        if (Array.isArray($$a)) {
          var $$v = null,
              $$i = _vm._i($$a, $$v);

          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.createForm, "has_delivery_order", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.createForm, "has_delivery_order", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.createForm, "has_delivery_order", $$c);
        }
      }
    }
  }), _vm._v(" has_delivery_order ")]), _c('label', {
    staticClass: "flex items-center gap-2 text-sm text-neutral-700"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.createForm.is_wooden_packing,
      expression: "createForm.is_wooden_packing"
    }],
    staticClass: "w-4 h-4",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.createForm.is_wooden_packing) ? _vm._i(_vm.createForm.is_wooden_packing, null) > -1 : _vm.createForm.is_wooden_packing
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.createForm.is_wooden_packing,
            $$el = $event.target,
            $$c = $$el.checked ? true : false;

        if (Array.isArray($$a)) {
          var $$v = null,
              $$i = _vm._i($$a, $$v);

          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.createForm, "is_wooden_packing", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.createForm, "is_wooden_packing", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.createForm, "is_wooden_packing", $$c);
        }
      }
    }
  }), _vm._v(" is_wooden_packing ")])])])]), _c('div', {
    staticClass: "flex justify-end gap-3 mt-6"
  }, [_c('button', {
    staticClass: "px-4 py-2 rounded-lg border border-neutral-300 text-neutral-600 hover:bg-neutral-50 font-medium",
    on: {
      "click": _vm.closeCreateResiModal
    }
  }, [_vm._v(" Batal ")]), _c('button', {
    staticClass: "px-4 py-2 rounded-lg bg-primary-500 text-white hover:bg-primary-600 font-medium disabled:opacity-50 disabled:cursor-not-allowed",
    attrs: {
      "disabled": !_vm.createForm.date || !_vm.createFormCustomer || !_vm.createForm.destination || !_vm.createForm.resi_number
    },
    on: {
      "click": _vm.submitCreateResi
    }
  }, [_vm._v(" Simpan ")])])])])], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }